import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Logo from '../../assets/images/logo-home.png';
import ProfPic from '../../assets/images/profile-icon.png';
import mobileMenu from '../../assets/images/icons/mobile-menu.png';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { userLogOut, resetStore } from './../../modules/auth/services';
import { _logout, _userTierInfoDoc } from '../httpservice/apis';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import ProfileDummy from '../../assets/images/profile-dummy.png';
import Button from 'react-bootstrap/Button';
import { userProfileInfo, listNotification } from './../../modules/profile/services';
import Notification from '../notificationss';
import { setViewAll } from './../../modules/results/services';
import upgradeImg from '../../assets/images/icons/upgrade-icon.png';
import { setChatPermission } from '../../modules/chatai/services';

// AI Search's own pages: the search page, its results and the "view all" lists
export const isAiSearchPath = (pathname) => pathname === '/ai-search' || pathname === '/results' || /-recomendations$/.test(pathname);

function Header() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const enabled = useSelector((state) => state?.chat?.permission);
    const token = useSelector((store) => store?.auth?.signin?.response?.data?.data?.token, shallowEqual);
    const userName = useSelector((store) => store?.auth?.signin?.response?.data?.data?.username, shallowEqual);
    const userNameSso = useSelector((store) => store?.auth?.sso_login_callback?.response?.data?.data?.username);
    const tokenSso = useSelector(
        (state) => state?.auth?.sso_login_callback?.response?.data?.data?.token, shallowEqual
    );
    const userInfo = useSelector((state) => state?.profile?.userProfile?.response?.data?.data?.results[0]);
    const notificationCount = useSelector((state) => state?.profile?.list_notification?.response?.data?.data?.count, shallowEqual);
    const notState = useSelector((state) => state?.profile?.list_notification?.error?.response?.statusText, shallowEqual);
    const viewAll = useSelector((state) => state?.results?.view_all);

    const [initialCount, setInitialCount] = useState(notificationCount);
    const [countDiff, setCountDiff] = useState(0);
    const [countStatus, setCountStatus] = useState();
    const [UpgradeShows, UpgradeSetShows] = useState(false);
    const UpgradehandleCloses = () => UpgradeSetShows(false);
    const UpgradehandleShows = () => UpgradeSetShows(true);
    const [profileImage, setProfileImage] = useState();
    const [isActive, setActive] = useState(false);
    const ToggleClass = () => setActive(!isActive);
    const { pathname } = useLocation();

    useEffect(() => {
        const fetchData = async (t) => {
            try {
                await _userTierInfoDoc(t, 'chat_ai');
                dispatch(setChatPermission(true));
            } catch (error) {
                dispatch(setChatPermission(false));
            }
        };
        if (token !== undefined) fetchData(token);
        else if (tokenSso !== undefined) fetchData(tokenSso);
    }, []);

    const setViewAllNotification = () => {
        if (viewAll === true) dispatch(setViewAll(false));
    };

    useEffect(() => {
        if (notificationCount !== initialCount) {
            setCountDiff(notificationCount - initialCount);
        }
    }, [notificationCount]);

    useEffect(() => {
        if (countStatus === true) setInitialCount(notificationCount);
    }, [countStatus]);

    const listNotifications = () => {
        if (token !== undefined) dispatch(listNotification(token));
        else if (tokenSso !== undefined) dispatch(listNotification(tokenSso));
    };

    useEffect(() => { listNotifications(); }, []);

    useEffect(() => {
        const interval = setInterval(() => { listNotifications(); }, 300000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (token !== undefined) dispatch(userProfileInfo(token));
        else if (tokenSso !== undefined) dispatch(userProfileInfo(tokenSso));
    }, []);

    useEffect(() => {
        if (userInfo?.profile_pic_path === null) setProfileImage(ProfPic);
        else setProfileImage(userInfo?.profile_pic_path);
    }, [userInfo?.profile_pic_path]);

    const userSignout = async () => {
        localStorage.setItem('status', false);
        dispatch(resetStore());
        localStorage.removeItem('persist:kush.ai');
        localStorage.removeItem('change');
        if (token !== undefined) dispatch(userLogOut(token));
        else if (tokenSso !== undefined) dispatch(userLogOut(tokenSso));
        navigate('/signin');
    };

    const BellIcon = (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
    );

    return (
        <div className="header-wrap">
            <div className="header-bar">
                <Container className="full-width-container">
                    <div className="header-bar__inner">
                        <h1 className="header-bar__logo">
                            <Link to="/"><img src={Logo} alt="DevDiscovery" /></Link>
                        </h1>

                        <div className={!isActive ? 'header-bar__menu mobilemenu-hidden' : 'header-bar__menu mobilemenu-active'}>
                            <div className="header-bar__links">
                                <NavLink
                                    to="/chat"
                                    className={({ isActive: active }) => `header-bar__link${active ? ' is-active' : ''}`}
                                    onClick={(e) => {
                                        if (!enabled) {
                                            e.preventDefault();
                                            UpgradehandleShows();
                                        }
                                        setActive(false);
                                    }}
                                >
                                    AI Chat
                                </NavLink>

                                <NavLink to="/ai-search" className={`header-bar__link${isAiSearchPath(pathname) ? ' is-active' : ''}`} onClick={() => setActive(false)}>AI Search</NavLink>
                                <NavLink to="/savedqueries" className={({ isActive: a }) => `header-bar__link${a ? ' is-active' : ''}`} onClick={() => setActive(false)}>Saved Queries</NavLink>
                                <NavLink to="/bookmarks" className={({ isActive: a }) => `header-bar__link${a ? ' is-active' : ''}`} onClick={() => setActive(false)}>Bookmarks</NavLink>

                                <span className="header-bar__divider" aria-hidden="true" />

                                <NavLink to="/aboutus" className={({ isActive: a }) => `header-bar__link${a ? ' is-active' : ''}`} onClick={() => setActive(false)}>About Us</NavLink>
                                <NavLink to="/helpandsupport" className={({ isActive: a }) => `header-bar__link${a ? ' is-active' : ''}`} onClick={() => setActive(false)}>Help &amp; Support</NavLink>

                                {/* Mobile-only: profile and logout inline links (avatar dropdown is hidden on mobile) */}
                                <span className="header-bar__divider header-bar__divider--mobile-only" aria-hidden="true" />
                                <button
                                    className="header-bar__link header-bar__mobile-profile-link"
                                    onClick={() => { navigate('/profile'); setActive(false); }}
                                >
                                    Profile
                                </button>
                                {token !== undefined && (
                                    <button
                                        className="header-bar__link header-bar__mobile-profile-link"
                                        onClick={() => { navigate('/changepassword'); setActive(false); }}
                                    >
                                        Change Password
                                    </button>
                                )}
                                <button
                                    className="header-bar__link header-bar__mobile-profile-link header-bar__mobile-logout"
                                    onClick={() => { userSignout(); setActive(false); }}
                                >
                                    Logout
                                </button>

                                <span className="header-bar__divider" aria-hidden="true" />

                                {/* Profile / Logout — desktop avatar dropdown only; mobile gets its own links below */}
                                <Dropdown
                                    onClick={() => { setCountDiff(0); setCountStatus(true); setViewAllNotification(); }}
                                    align="end"
                                    className="notification-dropdown header-bar__notif"
                                >
                                    <Dropdown.Toggle variant="success" id="dropdown-basic" className="notification-button">
                                        {notificationCount !== 0 && notificationCount && (
                                            <span className="noti-count">{notificationCount}</span>
                                        )}
                                        {BellIcon}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu><Notification /></Dropdown.Menu>
                                </Dropdown>

                                <Dropdown align="end" className="header-bar__avatar">
                                    <Dropdown.Toggle variant="success" id="dropdown-basic" className="avatar-toggle">
                                        <span className="user-img">
                                            <img src={userInfo?.profile_pic_path ? userInfo?.profile_pic_path : ProfileDummy} alt="user" />
                                        </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => { navigate('/profile'); setActive(false); }}>Profile</Dropdown.Item>
                                        {token !== undefined && (
                                            <Dropdown.Item onClick={() => { navigate('/changepassword'); setActive(false); }}>Change Password</Dropdown.Item>
                                        )}
                                        <Dropdown.Item onClick={userSignout}>Logout</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>

                        <div className="header-bar__mobile-actions">
                            <Dropdown
                                onClick={() => { setCountDiff(0); setCountStatus(true); setViewAllNotification(); }}
                                align="end"
                                className="notification-dropdown notification-mobile-only"
                            >
                                <Dropdown.Toggle variant="success" id="dropdown-basic" className="notification-button">
                                    {notificationCount !== 0 && notificationCount && (
                                        <span className="noti-count">{notificationCount}</span>
                                    )}
                                    {BellIcon}
                                </Dropdown.Toggle>
                                <Dropdown.Menu><Notification /></Dropdown.Menu>
                            </Dropdown>

                            <button onClick={ToggleClass} className="mobile-menu" aria-label="Toggle menu">
                                <img src={mobileMenu} alt="" />
                            </button>
                        </div>
                    </div>
                </Container>
            </div>

            <Modal show={UpgradeShows} size="md" centered className="common-modal">
                <Modal.Body>
                    <div className="upgrade-pop-wrap">
                        <div className="upgrade-img"><img src={upgradeImg} alt="" /></div>
                        <h3 className="upgrade-title">Premium feature!</h3>
                        <p>Please contact your admin to enable this feature.</p>
                        <div className="upgrade-btn"><Button onClick={UpgradehandleCloses}>OK</Button></div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Header;
